import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { Rating } from '../../rating/rating.component';
import { TranslateModule } from '@ngx-translate/core';

/**
 * ### **RatingEditComponent *
 *
 * **Selector:** ``<app-rating-edit>``
 *
 * Un componente es un bloque, que contiene un template, contiene estilos y contiene la lógica, en este caso es el Componente
 * encargado de renderizar el modal que se encarga de editar una calificación.
 */
@Component({
  selector: 'app-rating-edit',
  imports: [MatDialogModule, Rating, TranslateModule],
  templateUrl: "./rating-edit.component.html",
  styleUrl: "./rating-edit.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RatingEdit {
  public readonly dialogRef = inject(MatDialogRef<RatingEdit>);
  public readonly data: { qualification: number; city: number; user: number } =
    inject(MAT_DIALOG_DATA);

  /** Variable que guardará la calificación*/
  protected readonly qualification = signal<number>(0);

  /**
   * Función encargada de recibir los datos e inicializar la variable de calificaión.
   * @param dialogRef Parrametro que le indica al comonente que tendra un comportamento de tipo modal.
   * @param data Objeto que recibira los datos que son enviados al componente.
   */
  constructor() {
    this.qualification.set(this.data.qualification);
  }

  /**
   * Función encargada de actualizar la calificación, para esto recibe un dato de tipo boolean que le indicara el
   * tipo de acción a realizar, ademas retornara la nueva calificación.
   * @param deleted Parametro que recibe un valor booleano, dependiendo del mismo se eliminara o actulizara la calificación
   */
  protected close(deleted: boolean): void {
    this.dialogRef.close({
      deleted: deleted,
      qualification: this.qualification(),
    });
  }

  /**
   * Función encargada de actualizar la calificación.
   * @param qualification Calificación a actualizar.
   */
  protected onQualification(qualification: number): void {
    this.qualification.set(qualification);
  }
}
